module.exports = __webpack_public_path__ + "static/maquete_4k-5b95334bf4a1fef8d157e08877ced256.jpg";